// Helper function to handle Firestore errors
export const getErrorMessage = (error) => {
  switch (error.code) {
    case 'already-exists':
      return 'This email is already on the waitlist.';
    case 'permission-denied':
      return 'Unable to join waitlist. Please try again.';
    case 'unavailable':
      return 'Service temporarily unavailable. Please try again later.';
    default:
      return error.message || 'An unexpected error occurred. Please try again.';
  }
};
